//polyfills
import 'core-js';
import 'raf/polyfill';
import React from 'react';
import ReactGA from "react-ga4";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import './index.scss';

const root = createRoot(document.getElementById("root") || document.createElement('div')); // for testing only;

ReactGA.initialize("G-W0CW97N231");
ReactGA.send("pageview");

root.render(
    <BrowserRouter>
        <Routes />
    </BrowserRouter>
);
